import { api } from '@/lib/api';
import type { Booking, BookingStatus, VendorSummary } from './types';

export async function fetch_vendor_bookings(status?: BookingStatus, date?: string): Promise<Booking[]> {
  const params: Record<string, string> = {};
  if (status) params.status = status;
  if (date) params.date = date;
  const res = await api.get<Booking[]>('/vendor/bookings', { params });
  return res.data;
}

export async function fetch_vendor_summary(): Promise<VendorSummary> {
  const res = await api.get<VendorSummary>('/vendor/bookings/summary');
  return res.data;
}

export type VendorBookingAction = 'accept' | 'decline' | 'start' | 'complete' | 'no-show';

export async function act_on_booking(
  id: string,
  action: VendorBookingAction,
  reason?: string,
): Promise<Booking> {
  const res = await api.post<Booking>(`/vendor/bookings/${id}/${action}`, reason ? { reason } : undefined);
  return res.data;
}

export async function reschedule_booking(id: string, slot_start: string): Promise<Booking> {
  const res = await api.post<Booking>(`/vendor/bookings/${id}/reschedule`, { slot_start });
  return res.data;
}

export async function set_vendor_notes(id: string, vendor_notes: string): Promise<Booking> {
  const res = await api.patch<Booking>(`/vendor/bookings/${id}/notes`, { vendor_notes });
  return res.data;
}

// ---- Walk-session OTP ----
export type WalkOtpKind = 'start' | 'end';

export type WalkOtpSendResult = {
  kind: string;
  expires_in_seconds: number;
  cooldown_seconds: number;
  /** DEV/TEST ONLY — present when the backend SMS provider is the stub (no real SMS). */
  debug_otp_code?: string;
};

export async function send_walk_otp(id: string, kind: WalkOtpKind): Promise<WalkOtpSendResult> {
  const res = await api.post<WalkOtpSendResult>(`/vendor/bookings/${id}/walk/${kind}/send-otp`);
  return res.data;
}

export async function verify_walk_otp(id: string, kind: WalkOtpKind, code: string): Promise<Booking> {
  const res = await api.post<Booking>(`/vendor/bookings/${id}/walk/${kind}/verify`, { code });
  return res.data;
}

export async function override_walk_end(id: string, reason: string): Promise<Booking> {
  const res = await api.post<Booking>(`/vendor/bookings/${id}/walk/end/override`, { reason });
  return res.data;
}

// ---- Walker settings (walk-OTP toggle) ----
export type WalkerSettings = { require_walk_otp: boolean };

export async function fetch_walker_settings(): Promise<WalkerSettings> {
  const res = await api.get<WalkerSettings>('/vendor/walker/settings');
  return res.data;
}

export async function update_walker_settings(require_walk_otp: boolean): Promise<WalkerSettings> {
  const res = await api.patch<WalkerSettings>('/vendor/walker/settings', { require_walk_otp });
  return res.data;
}
